import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Get } from "../services/MainApi";
import md5 from 'md5';
import { Icon } from "@iconify/react";
import { useAppStore } from "../zustand/useAppStore";
import { motion } from 'framer-motion';
import { useAuthStore } from "../zustand/useAuthStore";
const Login = () => {

  const navigate = useNavigate();

  const [showMenu, setShowMenu] = useState(false);
  const [FinancialYears, setFinancialYears] = useState([]);
  
  const {auth, login, isLoggingIn, expiration, setExpiration} = useAuthStore()

  
  const handleClose = () => setShowMenu(false);



  

  const { themeMode , toggleTheme } = useAppStore();

  const isDarkMode = themeMode === 'dark';





  const [userInfo, setuserInfo] = useState({
    year: '',
    username: '',
    password: '',
  });

  useEffect(() => {
    if (auth) {
      navigate(`/`);
    } else {
      navigate(`/login`);
    }
  }, [auth,navigate]);

  useEffect(() => {
    fetchYears();
  }, []);

  const fetchYears = async () => {

    try {
      const res = await Get('', 'FinancialYears.php');
      if (res.success && res.data?.length > 0) {
        setFinancialYears(res.data);
        setuserInfo(prev => ({ ...prev, year: res.data[0].value }));
      }
    } catch (error) {
      console.log(error);
    } finally {

    }
  };

  const onChangeValue = (e) => {
    setuserInfo({
      ...userInfo,
      [e.target.name]: e.target.value
    });
  }

  const loginUser = async (event) => {
    event.preventDefault();

    login({ 
        ...userInfo, 
        password: md5(userInfo.password), 
        expiration: Number(expiration) 
      })
   
  };

  return (
    <div className="min-h-screen bg-bg-primary flex flex-col transition-colors duration-300 relative overflow-hidden" dir="rtl">
      
      {/* Background Decorative Elements (Optional, matches modern ERPs) */}
      <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-brand-primary opacity-5 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-[-10%] left-[-5%] w-96 h-96 bg-purple-600 opacity-5 rounded-full blur-3xl pointer-events-none"></div>

      {/* Header Area */}
      <header className="w-full flex items-center justify-between p-4 md:px-8 bg-bg-secondary border-b border-border shadow-sm z-50 relative">
        <div className="relative flex gap-2">
          {/* Settings Toggle Button */}
          <button
            onClick={() => setShowMenu(!showMenu)}
            className={`flex items-center justify-center p-2.5 rounded-xl transition-all duration-200 ${showMenu ? 'bg-brand-primary text-white shadow-md' : 'bg-bg-tertiary text-text-secondary hover:text-brand-primary hover:bg-brand-light'}`}
            title="إعدادات الدخول"
          >
            <Icon icon={showMenu ? "solar:close-circle-bold-duotone" : "solar:settings-bold-duotone"} className="text-2xl" />
          </button>
            <button 
              onClick={() => toggleTheme()} 
              className="flex items-center justify-center p-2.5 rounded-xl transition-all duration-200 bg-bg-tertiary rounded-xl text-text-secondary hover:text-brand-primary  transition-colors "
              title="تغيير المظهر"
            >
              <motion.div
                initial={false}
                animate={{ rotate: isDarkMode ? 0 : 180, }}
                transition={{ duration: 0.4, type: "spring", stiffness: 200 }}
              >
                <Icon 
                  icon={isDarkMode ? "solar:moon-stars-bold-duotone" : "solar:sun-2-bold-duotone"} 
                  className="text-2xl" 
                />
              </motion.div>
            </button>
          {/* Floating Settings Dropdown Panel */}
          {showMenu && (
            <>
              {/* Invisible overlay to close menu when clicking outside */}
              <div className="fixed inset-0 z-40" onClick={handleClose}></div>
              
              <div className="absolute top-[120%] right-0 w-72 bg-bg-secondary border border-border rounded-2xl shadow-xl p-5 z-50 animate-in slide-in-from-top-2 fade-in duration-200">
                <div className="flex items-center gap-2 mb-4 border-b border-border pb-3">
                  <Icon icon="solar:server-square-bold-duotone" className="text-brand-primary text-xl" />
                  <h3 className="font-bold text-text-primary text-base">إعدادات النظام</h3>
                </div>

                <div className="space-y-4">
                  <div className="flex flex-col gap-1.5">
                    <label className="text-xs font-bold text-text-secondary">السنة المالية</label>
                    <select 
                      className="w-full bg-bg-tertiary border border-border rounded-xl px-3 py-2.5 text-text-primary focus:border-brand-primary outline-none transition-colors text-sm" 
                      id="year" 
                      value={userInfo.year} 
                      name="year" 
                      onChange={onChangeValue} 
                      required
                    >
                      {FinancialYears.map((item, i) => (
                        <option key={i} value={item.value}>{item.label}</option>
                      ))}
                    </select>
                  </div>

                  <div className="flex flex-col gap-1.5">
                    <label className="text-xs font-bold text-text-secondary">مدة الجلسة (تسجيل خروج تلقائي)</label>
                    <select 
                      className="w-full bg-bg-tertiary border border-border rounded-xl px-3 py-2.5 text-text-primary focus:border-brand-primary outline-none transition-colors text-sm" 
                      id="expiration" 
                      value={expiration} 
                      name="expiration" 
                      onChange={(e) => setExpiration(e.target.value) } 
                      required
                    >
                      <option value={"60"}>ساعة واحدة</option>
                      <option value={"180"}>3 ساعات</option>
                      <option value={"720"}>12 ساعة</option>
                      <option value={"1440"}>يوم كامل</option>
                    </select>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        {/* Brand Logo / Name */}
        <div className="font-black text-2xl tracking-tight text-transparent bg-clip-text bg-gradient-to-l from-brand-primary to-purple-600 drop-shadow-sm select-none">
          فيوتشر سويفت
        </div>
      </header>

      {/* Main Login Card */}
      <main className="flex-1 flex items-center justify-center p-4 z-10">
        <div className="w-full max-w-md bg-bg-secondary border border-border rounded-[2rem] p-8 shadow-2xl relative overflow-hidden">
          
          {/* Card Accent Line */}
          <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-brand-primary to-purple-600"></div>

          <div className="text-center mb-8 pt-2">
            <div className="w-20 h-20 bg-brand-light text-brand-primary rounded-2xl flex items-center justify-center mx-auto mb-5 shadow-inner">
              <Icon icon="solar:user-circle-bold-duotone" className="text-5xl" />
            </div>
            <h1 className="text-2xl font-black text-text-primary mb-2">مرحباً بك مجدداً</h1>
            <p className="text-sm font-bold text-text-secondary">قم بتسجيل الدخول للوصول إلى لوحة التحكم</p>
          </div>

          <form onSubmit={loginUser} className="space-y-5">
            
            {/* Username Input */}
            <div className="flex flex-col gap-1.5">
              <label htmlFor="username" className="text-sm font-bold text-text-secondary px-1">اسم المستخدم</label>
              <div className="relative">
                <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none text-text-secondary">
                  <Icon icon="solar:user-bold-duotone" className="text-xl opacity-70" />
                </div>
                <input 
                  className="w-full bg-bg-tertiary border border-border rounded-xl pr-12 pl-4 py-3.5 text-text-primary focus:border-brand-primary focus:ring-1 focus:ring-brand-primary outline-none transition-all font-medium" 
                  id="username" 
                  name="username" 
                  onChange={onChangeValue} 
                  value={userInfo.username}
                  type="text" 
                  placeholder="اسم المستخدم" 
                  required
                />
              </div>
            </div> 
                
            {/* Password Input */}
            <div className="flex flex-col gap-1.5">
              <label htmlFor="password" className="text-sm font-bold text-text-secondary px-1">كلمة المرور</label>
              <div className="relative">
                <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none text-text-secondary">
                  <Icon icon="solar:lock-password-bold-duotone" className="text-xl opacity-70" />
                </div>
                <input 
                  className="w-full bg-bg-tertiary border border-border rounded-xl pr-12 pl-4 py-3.5 text-text-primary focus:border-brand-primary focus:ring-1 focus:ring-brand-primary outline-none transition-all font-medium" 
                  id="password" 
                  name="password" 
                  onChange={onChangeValue} 
                  value={userInfo.password}
                  type="password" 
                  placeholder="كلمة المرور" 
                  required
                />
              </div>
            </div>

            {/* Forgot Password Link */}
            <div className="flex justify-start px-1 pt-1">
              <button type="button" className="text-xs font-bold text-brand-primary hover:text-brand-hover transition-colors">
                نسيت كلمة المرور؟
              </button>
            </div>

            {/* Submit Button */}
            <button 
              type="submit" 
              className="w-full mt-4 bg-brand-primary hover:bg-brand-hover text-white font-bold py-4 rounded-xl transition-all shadow-lg hover:shadow-brand-primary/30 flex items-center justify-center gap-2 text-base"
            >
             {isLoggingIn
             ?  <div className="m-auto animate-spin">
                  <svg aria-hidden="true" className="w-6 h-6 text-white/30 fill-white" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                  </svg>
                </div> 
             : <>
               <Icon icon="solar:login-2-bold-duotone" className="text-xl" />
              تسجيل الدخول
              </>}
             
            </button>

          </form>
        </div>
      </main>

    </div>
  );
};

export default Login;